import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import axiosConstants from "./axiosConstants";
import { domainCode } from "../helpers/data/userAndPermissions";

const settings = {
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json;charset",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Credentials": true,
    "X-XSRF-TOKEN": axiosConstants.XSRF,
    "x-interswitch-domain": domainCode
  }
};

const baseURLCert =
  process.env.NODE_ENV === "production"
    ? "isw-itg-portlet-cert/"
    : "https://interswitch-tokenization-gateway.k8.isw.la/itg/config-certs";

const baseURLITG =
  process.env.NODE_ENV === "production"
    ? "isw-itg-portlet-base/"
    : "https://interswitch-tokenization-gateway.k8.isw.la/itg/config/api/v1";
const baseURLCTS =
  process.env.NODE_ENV === "production"
    ? "isw-itg-portlet-cts/"
    : `https://card-tokenization-service.k8.isw.la/card-tokenization/api`;

const baseURLReport =
  process.env.NODE_ENV === "production"
    ? "isw-itg-portlet-report/"
    : "https://tokenization-reporting-service.k8.isw.la/trs/api/v1";

const instanceITG = axios.create({ ...settings, baseURL: baseURLITG });
const instanceCTS = axios.create({ ...settings, baseURL: baseURLCTS });
const instanceCert = axios.create({ ...settings, baseURL: baseURLCert });
const instanceReport = axios.create({
  ...settings,
  baseURL: baseURLReport
});

instanceITG.interceptors.request.use(config => {
  // eslint-disable-next-line no-param-reassign
  config.headers["x-interswitch-domain"] = domainCode;
  return config;
});

instanceReport.interceptors.request.use(config => {
  // eslint-disable-next-line no-param-reassign
  config.headers["x-interswitch-domain"] = domainCode;
  return config;
});

console.log("env: ", process.env.NODE_ENV);
if (process.env.NODE_ENV !== "production") {
  instanceITG.defaults.headers.common.Authorization =
    "Bearer eyJhbGciOiJSUzI1NiJ9.eyJsYXN0TmFtZSI6ImlzdyIsImZpcnN0TG9naW4iOmZhbHNlLCJ1c2VyX25hbWUiOiJhZ2Jpc3dAc2hhcmtsYXNlcnMuY29tIiwibW9iaWxlTm8iOm51bGwsImNsaWVudF9pZCI6InNtYXJ0Y2FyZHByb2Nlc3MiLCJmaXJzdE5hbWUiOiJhZ2VuY3lfYmFua2luZyIsImVtYWlsVmVyaWZpZWQiOnRydWUsImF1ZCI6WyJjYXJkbGVzcy1zZXJ2aWNlIiwiaW5jb2duaXRvIiwiaXN3LWNvcmUiLCJpc3ctcG9zdC1vZmZpY2UiLCJwYXNzcG9ydCIsInNhZmV0b2tlbi1hZG1pbi1hcGkiLCJzY3AiLCJ2YXVsdCJdLCJzY29wZSI6WyJwcm9maWxlIl0sImV4cCI6MTcxMDg5NDkxMiwibW9iaWxlTm9WZXJpZmllZCI6ZmFsc2UsImNsaWVudF9uYW1lIjoiU21hcnRjYXJkcHJvY2VzcyIsImp0aSI6IjVmN2U0NTYwLTNjMGQtNDZiNC1iYjA0LWQ4MmQ0NWFjOTAwNCIsImVtYWlsIjoiYWdiaXN3QHNoYXJrbGFzZXJzLmNvbSIsInBhc3Nwb3J0SWQiOiJFQjFDMTJBQi1FODQwLTRDNEMtODI4MS03QTc3NjA2QkFFMDIifQ.N_OFjACIEdHhiF8Az_QKp7J7H3t37cLTOLTaEMK9E0H1cRBRW1X3WNlSSmLH0yLTdvLfC_LNN7solXIuAAuYVOTG5EOu72t1sssZhfE_5UN5vXOVk1cwdp55RS6WNEWTd1pCurYbIzgnmk0NUj5Hd_SjISdCyNwLH0fW0rfI0-KZ-sh0xxPS653-4lPmXPa5khacrW-FP17ugOpwEF4s98Vl3PF8qqwWRmf0YcoLLw9uRH-Tabwha8KRF9KWWj0KRyzCEVJCH-YcwlSe6ZA3Ku8ivGAxKGDxRoEmpXxa_6rP5ENForTJVnZRSm8DTb86floPeygQRSmtmQKEAvoCGw";
  instanceCTS.defaults.headers.common.Authorization =
    "Bearer eyJhbGciOiJSUzI1NiJ9.eyJsYXN0TmFtZSI6ImlzdyIsImZpcnN0TG9naW4iOmZhbHNlLCJ1c2VyX25hbWUiOiJhZ2Jpc3dAc2hhcmtsYXNlcnMuY29tIiwibW9iaWxlTm8iOm51bGwsImNsaWVudF9pZCI6InNtYXJ0Y2FyZHByb2Nlc3MiLCJmaXJzdE5hbWUiOiJhZ2VuY3lfYmFua2luZyIsImVtYWlsVmVyaWZpZWQiOnRydWUsImF1ZCI6WyJjYXJkbGVzcy1zZXJ2aWNlIiwiaW5jb2duaXRvIiwiaXN3LWNvcmUiLCJpc3ctcG9zdC1vZmZpY2UiLCJwYXNzcG9ydCIsInNhZmV0b2tlbi1hZG1pbi1hcGkiLCJzY3AiLCJ2YXVsdCJdLCJzY29wZSI6WyJwcm9maWxlIl0sImV4cCI6MTcxMDg5NDkxMiwibW9iaWxlTm9WZXJpZmllZCI6ZmFsc2UsImNsaWVudF9uYW1lIjoiU21hcnRjYXJkcHJvY2VzcyIsImp0aSI6IjVmN2U0NTYwLTNjMGQtNDZiNC1iYjA0LWQ4MmQ0NWFjOTAwNCIsImVtYWlsIjoiYWdiaXN3QHNoYXJrbGFzZXJzLmNvbSIsInBhc3Nwb3J0SWQiOiJFQjFDMTJBQi1FODQwLTRDNEMtODI4MS03QTc3NjA2QkFFMDIifQ.N_OFjACIEdHhiF8Az_QKp7J7H3t37cLTOLTaEMK9E0H1cRBRW1X3WNlSSmLH0yLTdvLfC_LNN7solXIuAAuYVOTG5EOu72t1sssZhfE_5UN5vXOVk1cwdp55RS6WNEWTd1pCurYbIzgnmk0NUj5Hd_SjISdCyNwLH0fW0rfI0-KZ-sh0xxPS653-4lPmXPa5khacrW-FP17ugOpwEF4s98Vl3PF8qqwWRmf0YcoLLw9uRH-Tabwha8KRF9KWWj0KRyzCEVJCH-YcwlSe6ZA3Ku8ivGAxKGDxRoEmpXxa_6rP5ENForTJVnZRSm8DTb86floPeygQRSmtmQKEAvoCGw";
  instanceCert.defaults.headers.common.Authorization =
    "Bearer eyJhbGciOiJSUzI1NiJ9.eyJsYXN0TmFtZSI6ImlzdyIsImZpcnN0TG9naW4iOmZhbHNlLCJ1c2VyX25hbWUiOiJhZ2Jpc3dAc2hhcmtsYXNlcnMuY29tIiwibW9iaWxlTm8iOm51bGwsImNsaWVudF9pZCI6InNtYXJ0Y2FyZHByb2Nlc3MiLCJmaXJzdE5hbWUiOiJhZ2VuY3lfYmFua2luZyIsImVtYWlsVmVyaWZpZWQiOnRydWUsImF1ZCI6WyJjYXJkbGVzcy1zZXJ2aWNlIiwiaW5jb2duaXRvIiwiaXN3LWNvcmUiLCJpc3ctcG9zdC1vZmZpY2UiLCJwYXNzcG9ydCIsInNhZmV0b2tlbi1hZG1pbi1hcGkiLCJzY3AiLCJ2YXVsdCJdLCJzY29wZSI6WyJwcm9maWxlIl0sImV4cCI6MTcxMDg5NDkxMiwibW9iaWxlTm9WZXJpZmllZCI6ZmFsc2UsImNsaWVudF9uYW1lIjoiU21hcnRjYXJkcHJvY2VzcyIsImp0aSI6IjVmN2U0NTYwLTNjMGQtNDZiNC1iYjA0LWQ4MmQ0NWFjOTAwNCIsImVtYWlsIjoiYWdiaXN3QHNoYXJrbGFzZXJzLmNvbSIsInBhc3Nwb3J0SWQiOiJFQjFDMTJBQi1FODQwLTRDNEMtODI4MS03QTc3NjA2QkFFMDIifQ.N_OFjACIEdHhiF8Az_QKp7J7H3t37cLTOLTaEMK9E0H1cRBRW1X3WNlSSmLH0yLTdvLfC_LNN7solXIuAAuYVOTG5EOu72t1sssZhfE_5UN5vXOVk1cwdp55RS6WNEWTd1pCurYbIzgnmk0NUj5Hd_SjISdCyNwLH0fW0rfI0-KZ-sh0xxPS653-4lPmXPa5khacrW-FP17ugOpwEF4s98Vl3PF8qqwWRmf0YcoLLw9uRH-Tabwha8KRF9KWWj0KRyzCEVJCH-YcwlSe6ZA3Ku8ivGAxKGDxRoEmpXxa_6rP5ENForTJVnZRSm8DTb86floPeygQRSmtmQKEAvoCGw";
  instanceReport.defaults.headers.common.Authorization =
    "Bearer eyJhbGciOiJSUzI1NiJ9.eyJsYXN0TmFtZSI6ImlzdyIsImZpcnN0TG9naW4iOmZhbHNlLCJ1c2VyX25hbWUiOiJhZ2Jpc3dAc2hhcmtsYXNlcnMuY29tIiwibW9iaWxlTm8iOm51bGwsImNsaWVudF9pZCI6InNtYXJ0Y2FyZHByb2Nlc3MiLCJmaXJzdE5hbWUiOiJhZ2VuY3lfYmFua2luZyIsImVtYWlsVmVyaWZpZWQiOnRydWUsImF1ZCI6WyJjYXJkbGVzcy1zZXJ2aWNlIiwiaW5jb2duaXRvIiwiaXN3LWNvcmUiLCJpc3ctcG9zdC1vZmZpY2UiLCJwYXNzcG9ydCIsInNhZmV0b2tlbi1hZG1pbi1hcGkiLCJzY3AiLCJ2YXVsdCJdLCJzY29wZSI6WyJwcm9maWxlIl0sImV4cCI6MTcxMDg5NDkxMiwibW9iaWxlTm9WZXJpZmllZCI6ZmFsc2UsImNsaWVudF9uYW1lIjoiU21hcnRjYXJkcHJvY2VzcyIsImp0aSI6IjVmN2U0NTYwLTNjMGQtNDZiNC1iYjA0LWQ4MmQ0NWFjOTAwNCIsImVtYWlsIjoiYWdiaXN3QHNoYXJrbGFzZXJzLmNvbSIsInBhc3Nwb3J0SWQiOiJFQjFDMTJBQi1FODQwLTRDNEMtODI4MS03QTc3NjA2QkFFMDIifQ.N_OFjACIEdHhiF8Az_QKp7J7H3t37cLTOLTaEMK9E0H1cRBRW1X3WNlSSmLH0yLTdvLfC_LNN7solXIuAAuYVOTG5EOu72t1sssZhfE_5UN5vXOVk1cwdp55RS6WNEWTd1pCurYbIzgnmk0NUj5Hd_SjISdCyNwLH0fW0rfI0-KZ-sh0xxPS653-4lPmXPa5khacrW-FP17ugOpwEF4s98Vl3PF8qqwWRmf0YcoLLw9uRH-Tabwha8KRF9KWWj0KRyzCEVJCH-YcwlSe6ZA3Ku8ivGAxKGDxRoEmpXxa_6rP5ENForTJVnZRSm8DTb86floPeygQRSmtmQKEAvoCGw";
}

interface AxiosInstanceType {
  get: (url: string, request?: AxiosRequestConfig) => Promise<AxiosResponse>;
  post: (url: string, data: any) => Promise<AxiosResponse>;
  put: (url: string, data: any) => Promise<AxiosResponse>;
  patch: (url: string, data: any) => Promise<AxiosResponse>;
  delete: (url: string, request?: AxiosRequestConfig) => Promise<AxiosResponse>;
}

const getAxiosInstance = (_instance: AxiosInstance) => {
  return {
    async get(url: string, request: AxiosRequestConfig | undefined) {
      try {
        const response = await _instance.get(url, request);
        return await Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async post(url: string, data: any) {
      try {
        const response = await _instance.post(url, data);
        return await Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async put(url: string, data: any) {
      try {
        const response = await _instance.put(url, data);
        return await Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async patch(url: string, data: any) {
      try {
        const response = await _instance.patch(url, data);
        return await Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async delete(url: string, request: AxiosRequestConfig | undefined) {
      try {
        const response = await _instance.delete(url, request);
        return await Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    }
  };
};

export const axiosInstanceITG: AxiosInstanceType =
  getAxiosInstance(instanceITG);

export const axiosInstanceCTS: AxiosInstanceType =
  getAxiosInstance(instanceCTS);

export const axiosInstanceCert: AxiosInstanceType =
  getAxiosInstance(instanceCert);

export const axiosInstanceReport: AxiosInstanceType =
  getAxiosInstance(instanceReport);
